import React, { FC, ReactElement } from 'react';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
  setAvailabilityRequest,
  setOfferMonthRange,
  // eslint-disable-next-line prettier/prettier
  setOpenDateSelector
} from '../../features/offerAvailability/offerAvailabilitySlice';
import { AvailabilityDateRequest, AvailableDates } from '../../features/offerAvailability/types';
import { setSelectedRoom } from '../../features/offerSearch/offerSearchSlice';
import { Offer } from '../../features/offerSearch/types';
import { RootState } from '../../redux/rootReducer';
import { createMonthList, getMonthEndDate, getMonthsBetweenDates } from '../../util/date';
import { OFFER_DATES_PATH, OFFER_ELIGIBILITY_PATH } from '../../util/strings';
import DopInformation from '../common/DopInformation/DopInformation';
import ParseHtml from '../common/ParseHtml';
import TravelDateInfo from '../common/TravelDateInfo/TravelDateInfo';
import withLocalization from '../hoc/withLocalization';
import RoomPriceInfo from './RoomPriceInfo';
import './RoomTypeInformation.scss';
interface RoomTypeProp {
  offer: Offer | undefined;
  history?: any;
  localize?: any;
  pin?: string;
  loc?: string;
  alternateLOC?: string;
  userRole?: any;
}

const RoomTypeInformation: FC<RoomTypeProp> = (props: RoomTypeProp): ReactElement => {
  const { localize, offer, pin, loc, alternateLOC } = props;
  const dispatch = useDispatch();
  const premiums =
    offer && offer.premiums
      ? offer?.premiums
          .filter((x) => x !== null)
          .join(', ')
          .trim()
      : '';
  const availabilityDates: AvailableDates = useSelector((state: RootState) => state.availabilityDates);
  const selectedHearingADACode: string | undefined = availabilityDates.hearingADACode;
  const selectedADARoomCode: string | undefined = availabilityDates.roomADACode;
  const monthNames = [
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#jan'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#feb'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#mar'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#apr'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#may'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#jun'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#jul'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#aug'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#sept'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#oct'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#nov'),
    localize('preview-sales-engine.static-content.copy.calendar-page.months-of-year#dec'),
  ];
  const onViewOfferClicked = (evt) => {
    const selectedIndex = parseInt(evt.target.id, 10);
    handleNavigation(selectedIndex, OFFER_DATES_PATH);
  };
  const onChooseDatesLaterClicked = (evt) => {
    const selectedIndex = parseInt(evt.target.id, 10);
    handleNavigation(selectedIndex, OFFER_ELIGIBILITY_PATH);
  };

  const handleNavigation = (selectedIndex: number, redirectionPath: string) => {
    if (offer && offer.roomTypes) {
      const selectedRoom = offer.roomTypes[selectedIndex];
      const offerStartDate = new Date(offer.bookFromDate);
      const offerEndDate = new Date(offer.bookToDate);
      const monthBetweenDates = getMonthsBetweenDates(offerStartDate, offerEndDate);
      const monthList = createMonthList(offerStartDate, offerEndDate, monthBetweenDates, monthNames);
      const startDate = new Date(offer.bookFromDate);
      const calculatedDate = new Date(startDate.setMonth(startDate.getMonth() + 1));
      const endString = getMonthEndDate(calculatedDate.getMonth(), calculatedDate.getFullYear());
      const calStartDate =
        offer.bookFromDate && offer.bookFromDate.length > 0 && offer.bookFromDate.indexOf('T') > 0
          ? offer.bookFromDate.split('T')[0]
          : offer.bookFromDate;
      const calEndDate =
        offer.bookToDate && offer.bookToDate.length > 0 && offer.bookToDate.indexOf('T') > 0
          ? endString
          : offer.bookToDate;
      let preferences: string[] | undefined = [];
      if (selectedHearingADACode !== undefined) {
        preferences.push(selectedHearingADACode);
      }
      if (selectedADARoomCode !== undefined) {
        preferences.push(selectedADARoomCode);
      }
      if (preferences.length === 0) {
        preferences = undefined;
      }
      const availabilityRequest: AvailabilityDateRequest = {
        accomodationCode: selectedRoom.accomodationCode,
        roomTypeCode: selectedRoom.roomTypeCode,
        beginDate: calStartDate,
        endDate: calEndDate,
        offerCode: offer.offerCode,
        pin: alternateLOC ? undefined : pin,
        loc: alternateLOC ? alternateLOC : loc,
        preferences: preferences,
      };
      dispatch(setSelectedRoom(selectedRoom));
      dispatch(setAvailabilityRequest(availabilityRequest));
      if (monthList) dispatch(setOfferMonthRange(monthList));
      if (redirectionPath === OFFER_ELIGIBILITY_PATH) {
        dispatch(setOpenDateSelector(true));
      }
      props.history?.push(redirectionPath);
    }
  };
  const roomTypes = offer?.roomTypes.map((room, index) => {
    return (
      <div key={index} className="offerDisplay">
        {room.maxAdditionalNights && room.maxAdditionalNights > 0 ? (
          <div className="additionalNightsRibbon">
            {localize('preview-sales-engine.static-content.copy.Labels.labels#additional-nights-ribbon-label')}
          </div>
        ) : (
          <></>
        )}

        <div className="row">
          <div className="col-md-7">
            <RoomPriceInfo lowSeasonCost={room.startingCost} highSeasonCost={room.highSeasonCost} />

            <div>
              {localize('preview-sales-engine.static-content.copy.select-offer-page.days-nights', [
                room.numberOfDays,
                room.numberOfNights,
              ])}
              <div className="vr"></div>
              {room.roomTypeDescription}
              <div className="vr"></div>
              {localize('preview-sales-engine.static-content.copy.select-offer-page.max-guests')} {room.sleepCapacity}
            </div>
            {premiums && (
              <p>
                <ParseHtml
                  htmlInput={`${localize('preview-sales-engine.static-content.copy.prospects.plustext')} ${premiums}`}
                ></ParseHtml>
              </p>
            )}
            <TravelDateInfo
              lowSeasonDateRanges={offer?.lowSeasonDateRanges}
              highSeasonDateRanges={offer?.highSeasonDateRanges}
              placement="top"
            />
          </div>
          <div className="col-md-5 rightAlign">
            <Button variant="primary roomTypeSelectButton" id={index.toString()} onClick={onViewOfferClicked}>
              {localize(
                'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.select-offer-page.choose-dates-now-button',
              )}
            </Button>
            <Button variant="primary roomTypeSelectButton" id={index.toString()} onClick={onChooseDatesLaterClicked}>
              {localize('preview-sales-engine.static-content.copy.calendar-page.choose-dates-later-button')}
            </Button>
            <DopInformation dopCodeDetails={offer.dopCodeDetails} />
          </div>
        </div>
      </div>
    );
  });
  return (
    <React.Fragment>
      <div className="roomTypePad">{roomTypes}</div>
    </React.Fragment>
  );
};
export default React.memo(withRouter(withLocalization(RoomTypeInformation)));
